import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close-nav",
  "use": "close-nav-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"close-nav\"><g><path d=\"M.343.343a1 1 0 011.414 0l9.9 9.9a1 1 0 01-1.414 1.414l-9.9-9.9a1 1 0 010-1.414z\" /><path d=\"M.343 11.657a1 1 0 010-1.414l9.9-9.9a1 1 0 011.414 1.414l-9.9 9.9a1 1 0 01-1.414 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol